import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3';
import Login from '@/pages/auth/login'

// Define and validate search params used by the login page and form
// const loginSearchSchema = z.object({
//   // For social/OAuth callbacks (might already be handled by parent? Check)
//   provider: z.string().optional(), 
//   callback: z.string().optional(), 
//   // For distinguishing desktop app flow
//   fromDesktop: z.string().optional(), 
//   desktop: z.string().optional(),
//   // For extension flow
//   source: z.enum(['extension']).optional(), 
//   redirect_uri: z.string().optional(), 
//   // For general redirects after login
//   redirect: z.string().optional(), 
//   // For potential errors passed back
//   error: z.string().optional(), 
//   // For potential tokens passed back (e.g., after social login server redirect)
//   token: z.string().optional(), 
//   expiry: z.string().optional(), 
// }).catchall(z.any()) // Allow other params but don't validate them strictly

export const Route = createFileRoute('/(auth)/login')({
  // validateSearch: loginSearchSchema,
  component: Login,
})
